/**
 * @name api constant
 * @author: maoliuliu
 * @email: liuliu_mao@intsig.net
 * @date: 2022/10/27 17:51
 */

const MOCK_URL = "https://web-api.intsig.net/mock/102/base-admin" // mocK平台的url
const SSO_REDIRECT = "https://web-sso-sandbox.intsig.net" // sso平台的url
const SSO_URL = "https://webapi-sso-sandbox.intsig.net"
const PLATFORM_ID = "5W40Ge48Ix7XcXYnevn7iFsS8jHzlRYn" // 平台id，每一个平台需要让sso平台提供一个唯一的平台id
// const BASE_URL = 'https://web-api.intsig.net/mock/108'
const BASE_URL = "https://web-project-api-sandbox.intsig.net"
const PERMISSION_URL = "https://webapi-permission.intsig.net"
const SDL_URL = "https://webapi-sdl.intsig.net"
export default {
    BAPI: BASE_URL,
    MAPI: MOCK_URL,
    SRED: SSO_REDIRECT,
    PID: PLATFORM_ID,
    SAPI: SSO_URL,
    PAPI: PERMISSION_URL,
    SDL_URL
}
